import * as SharedAcross from '../utilities/SharedAcross';
import TableWrapRows from '../StockItems/TableWrapRows';

function App(props) {

  var anItem = props.anItem;
  var getOrig = props.getOrig;
  var toggler = props.toggler;
  var highlightAnItem = props.highlightAnItem;


      var whatDrop = anItem.i;
      var orig = getOrig(whatDrop);
      var optionsButtonStyle = [];
      if (whatDrop === 'buttonOutline'){
        optionsButtonStyle = [{t:'Outline', i:'outline'}, {t:'Solid',i:false}];
      }else if (whatDrop === 'buttonColor'){
        optionsButtonStyle = SharedAcross.buttonStyles();
      // }else if (whatDrop === 'alertStyle'){
      //   optionsButtonStyle = [{t:'Primary', i:'alert-primary'}, {t:'Secondary',i:'alert-secondary'},{t:'Success',i:'alert-success'}, {t:'Danger',i:'alert-danger'}, {t:'Warning',i:'alert-warning'}, {t:'Info',i:'alert-info'}, {t:'Light',i:'alert-light'}, {t:'Dark', i:'alert-dark'}];
      }else if (whatDrop === 'buttonSize'){
        optionsButtonStyle = [{t:'Large', i:'btn-lg'}, {t:'Normal',i:false}, {t:'Small',i:'btn-sm'}];
      }else if (whatDrop === 'inputSize'){
        optionsButtonStyle = [{t:'Large', i:'form-control-lg'}, {t:'Normal',i:false}, {t:'Small',i:'form-control-sm'}];
      }else if (whatDrop === 'borderStyle'){
        optionsButtonStyle = [{t:'Solid', i:'solid'},{t:'Dotted', i:'dotted'},{t:'Dashed', i:'dashed'},{t:'None', i:'none'}];

      }else if (whatDrop === 'verticalAlign'){
        optionsButtonStyle = [{t:'Top', i:'top'}, {t:'Middle',i:'middle'}, {t:'Bottom',i:'bottom'}];
      }

    
      var nosCols = optionsButtonStyle.length;
      if (whatDrop === 'inputSize'){
        nosCols = 2;
      }else if (nosCols > 3){
        nosCols = 3;
      }
      var rows2 = SharedAcross.convertToGrid(optionsButtonStyle, nosCols, true).map((aRow, index)=>{
        var cells = aRow.map((aCell, index2)=>{
          if (aCell){
            var styleButton = {width:'33%', textAlign:'center', padding:'5px', cursor:'pointer'};
            var obj;
            if (whatDrop === 'buttonSize'){
              styleButton.verticalAlign = 'middle';
              var preText;
              var b3Style = {}
              if (orig === aCell.i){
                b3Style.boxShadow = '0 0 0 0.2rem rgba(38, 143, 255, 0.5)'
                preText = 'btn btn-primary ';
              }else{
                b3Style.boxShadow = 'none';
                preText = 'btn btn-secondary ';
              }

              obj = <button className={preText + aCell.i} style={b3Style}>Aa</button>
//
            }else if (whatDrop === 'buttonColor'){
              if (aCell.i === 'light' ){
                styleButton.background = 'black';
              }
              var cc1 = 'btn btn-' + aCell.i;
              var btnStyle = {}
              if (orig === aCell.i){
                if (aCell.i === 'light' ){
                btnStyle.border = '3px solid blue';
                }else{
                btnStyle.border = '3px solid black';

                }
              }
              obj = <button className={cc1} style={btnStyle} >Aa</button>
//              
            }else if (whatDrop === 'buttonOutline'){
              var preText3 = '';
              if (aCell.i === 'outline' ){
                preText3 += 'outline-'
              }
              var bStyle = {};
              if (aCell.i === orig){
                bStyle.boxShadow = '0 0 0 0.2rem rgba(38, 143, 255, 0.5)';
              }
              obj = <button className={'btn btn-'+preText3+'primary'} style={bStyle}>Aa</button>
//
            }else if (whatDrop === 'alertStyle'){
              var b6Style = {};
             if (aCell.i === orig){
                b6Style.boxShadow = '0 0 0 0.2rem rgba(0, 0, 0, 0.5)'
              }else{
                b6Style.boxShadow = 'none'
              }
               obj = <div className={'alert ' + aCell.i} role='alert' style={b6Style}>Alert</div>
//

//
            }else if (whatDrop === 'inputSize'){
              var b4Style = {};
              if (aCell.i === orig){
                b4Style.boxShadow = '0 0 0 0.2rem rgba(38, 143, 255, 0.5)'
              }else{
                b4Style.boxShadow = 'none';
              }

              obj = <input className={'form-control ' + aCell.i} style={b4Style} type='text' placeholder={aCell.t} aria-label={aCell.n}/>
            }else if (whatDrop === 'borderStyle'){
              var styleBorder = {borderStyle:aCell.i, padding:'5px', margin:'5px', borderColor:'black', width:'80%', borderWidth:'1px'};

              if (orig === aCell.i){
                styleBorder.backgroundColor = '#f0e7da';
                styleBorder.opacity = 0.8;
              }
              obj = <div style={styleBorder}>{aCell.t}</div>
//              
            }else if (whatDrop === 'verticalAlign'){

              styleButton.verticalAlign = aCell.i;
              styleButton.height = 50;
              styleButton.border = '1px solid black';
              if (orig === aCell.i){
                styleButton.backgroundColor = 'blue';
                styleButton.color = 'white'
              }else{
                styleButton.color = 'black';
              }
              obj = aCell.t
//

            }else{
              console.warn(whatDrop)
            }
            return <td key={index2} style={styleButton} onClick={toggler(aCell.i, anItem.i, aCell.aC)}>{obj}</td>
          }else{
            return <td key={index2} style={{width:'33%'}}></td>
//
          }
        })
        return <tr key={index}>{cells}</tr>
//
      })

      var segmentStyle = {}
      if (highlightAnItem && highlightAnItem.t === 'style' && highlightAnItem.v === anItem.i){
        segmentStyle.backgroundColor = '#5cb0fa'
      }
      return (<td style={segmentStyle}>{anItem.n} <TableWrapRows rows={rows2} /></td>)

}




//
export default App;
